export const CalculateStaticAnalysis = (
  project,
  enqueueSnackbar,
  resultHandler
) => {
  let getAPI = "/api/analysis";
  if (process.env.NODE_ENV !== "production") {
    getAPI = "http://localhost:7071" + getAPI;
  }
  try {
    fetch(getAPI, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(project.toJS()),
    }).then((response) => {
      if (!response.ok) {
        response.text().then((text) => {
          throw Error(response.statusText + ": " + text);
        });
      } else {
        response.json().then((parsedResponse) => resultHandler(parsedResponse));
      }
    });
  } catch (e) {
    enqueueSnackbar(e.message, { variant: "error" });
  }
};

export const CalculateStaticAnalysisWithPeriod = (
  project,
  period,
  enqueueSnackbar,
  resultHandler
) => {
  let getAPI = "/api/analysis/" + period + "/specificPeriod";
  if (process.env.NODE_ENV !== "production") {
    getAPI = "http://localhost:7071" + getAPI;
  }
  try {
    fetch(getAPI, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(project.toJS()),
    }).then((response) => {
      if (!response.ok) {
        response.text().then((text) => {
          throw Error(response.statusText + ": " + text);
        });
      } else {
        response.json().then((parsedResponse) => resultHandler(parsedResponse));
      }
    });
  } catch (e) {
    enqueueSnackbar(e.message, { variant: "error" });
  }
};

export const CalculateStaticAnalysisWithPreBaseline = (
  project,
  view,
  enqueueSnackbar,
  resultHandler
) => {
  let getAPI = "/api/analysis/" + project.id;
  if (process.env.NODE_ENV !== "production") {
    getAPI = "http://localhost:7071" + getAPI;
  }
  try {
    view.showAnalysisLoadingMessage = true;
    fetch(getAPI, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: '',
    }).then((response) => {
      if (!response.ok) {
        response.text().then((text) => {
          throw Error(response.statusText + ": " + text);
        });
      } else {
        response.json().then((parsedResponse) => resultHandler(parsedResponse));
        view.showAnalysisLoadingMessage = false;
      }
    });
  } catch (e) {
    enqueueSnackbar(e.message, { variant: "error" });
  }
};
